import request, { buildFiles, UPLOAD_HEADERS } from '../../../../common/utils/request';

const getMoodboardsDocs = moodboard_id => {
  return request('get', `/design/moodboards/${moodboard_id}/documents`);
};

const getBriefDocs = moodboard_id => {
  return request('get', `/design/moodboards/${moodboard_id}/documents/brief`);
};
const updateMoodboardsDocs = moodboard_id => {
  return request('put', `/design/moodboards/${moodboard_id}/documents`);
};
const deleteMoodboardsDocs = (moodboard_id, docId) => {
  return request('delete', `/design/moodboards/${moodboard_id}/documents/${docId}`);
};
const createMoodboardsDocs = (moodboard_id, document) => {
  return request('post', `/design/moodboards/${moodboard_id}/documents`, { document });
};

export {
  getMoodboardsDocs,
  updateMoodboardsDocs,
  deleteMoodboardsDocs,
  createMoodboardsDocs,
  getBriefDocs,
};



// WEBPACK FOOTER //
// ./app/javascript/design/routes/Workdesk/api/docs.api.js